import styled from 'styled-components';
import { Button } from '../button';
import { Overline, Subtitle2 } from '../typography';
import { getColor, getColorShade, getSizeBy } from '../../../src/styled/utils';
import { ListSubheader } from '../list-subheader';
import { List } from '../list';
export const AsOfWrap = styled(Overline) `
  align-self: end;
  color: ${getColorShade('onSurface', 'lowEmphasis')};
  font-weight: 700;
`;
export const ExitButton = styled(Button) `
  padding: 0;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
`;
export default styled.footer `
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: ${(props) => props.$withExit ? '1fr min-content min-content' : '1fr min-content'};
  gap: ${getSizeBy(3)};
  align-items: center;
  padding: 0;
`;
export const MenuSubheader = styled(ListSubheader) `
  height: ${getSizeBy(5.75)};
  padding: ${getSizeBy(2)};
  background-color: ${getColor('background')};
`;
export const OverlineText = styled(Overline) `
  color: ${getColor('onSurface')};
  font-weight: 700;
`;
export const ConnectButton = styled(Subtitle2) `
  color: ${getColor('link')};
  text-align: right;
`;
export const ListStyled = styled(List) `
  min-width: 250px;
`;
